import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {CrudActionTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudActionTypes';
import {CustomAccessKeys} from '@/classes/clientOnly/permissionTreeResources/enums/CustomAccessKeys';
import {CrudManagerDirective} from '@/classes/clientOnly/CrudManagerDirective';
import store from '@/store';

type CreateAccess = {
    entity: CrudEntityTypes.ACQUISITION_LIST | CrudEntityTypes.EMPLOYEE | CrudEntityTypes.INSTITUTION;
    action: CrudActionTypes;
    accessKeys?: string[];
};

/**
 * Rights needed to create an acquisition list (list overview, "Neu" menu of the app bar, applicant card and context action).
 * Driving times via Google (paid) are optional and checked separately with {@link canUseDistanceMatrix}.
 */
export const ACQUISITION_LIST_CREATE_ACCESS: CreateAccess[] = [{
    entity: CrudEntityTypes.ACQUISITION_LIST,
    action: CrudActionTypes.CREATE,
}, {
    entity: CrudEntityTypes.EMPLOYEE,
    action: CrudActionTypes.READ,
    accessKeys: ['firstName', 'lastName', 'address', 'isTeacher', 'isEmployee', 'isApplicant', 'isActive'],
}, {
    entity: CrudEntityTypes.INSTITUTION,
    action: CrudActionTypes.READ,
    accessKeys: ['name', 'address', 'contactInformation'],
}];

/** Single check for all places that offer creating an acquisition list */
export const canCreateAcquisitionList = (): boolean => ACQUISITION_LIST_CREATE_ACCESS.every((access) => CrudManagerDirective.checkAbility({
    action: access.action,
    entity: access.entity,
    keys: access.accessKeys,
}));

/** Driving times via the Google Distance Matrix are paid and need their own right */
export const canUseDistanceMatrix = (): boolean => !!store.state.crudAccessManager.getCustom(CustomAccessKeys.USE_GMAPS_DISTANCE_MATRIX);
